<template>
  <div>
    <el-form label-position="top" ref="templateForm" :rules="rules" label-width="80px" :model="templateForm">
      <el-form-item label="" prop="template">
        <el-input type="textarea" :rows="7" :placeholder="`模板内容格式实例：\n你好，\${name}\n你的ID是\${id}\n激活码是\$｛code｝`"
          v-model="templateForm.template">
        </el-input>
      </el-form-item>
    </el-form>
    <div style="display: flex;justify-content: right;">
      <div class="submit" @click="resetTemplate">重置</div>
      <div class="submit primary" @click="submitTemplate" disabled>提交</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'templateEdit',
  components: {},
  props: {
    editType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      templateForm: {
        template: '',
        editType: this.editType
      },
      rules: {
        template: [
          { required: true, message: '请输入模板', trigger: 'blur' }
        ],
      },
      templateHistory: ''
    }
  },
  mounted () {
    this.initTemplate()
  },
  methods: {
    // 模板反显
    async initTemplate () {
      console.log('TODO !!!!!!!!!!!!')
      // try {
      //   const res = this.$callApi("", {
      //     editType: this.editType
      //   }, { mask: true })
      //   this.$message(res.message);
      //   this.templateHistory = res.template
      //   this.templateForm.template = this.templateHistory
      // } catch (error) {
      //   console.error('error', error)
      //   this.$message.error(error.message);
      // }
    },
    async submitTemplate () {
      try {
        await this.$refs.templateForm.validate()
        console.log('提交', this.templateForm)
        // this.$callApi("", this.feedbackForm, { mask: true }).then(res => {
        //   this.$message(res.message);
        // }).catch(e => {
        //   this.$message.error(e.message);
        // })
      } catch (error) {
        console.error('提交错误', error)
      }
    },
    async resetTemplate () {
      this.templateForm.template = this.templateHistory
      this.templateForm.template = `阿斯顿撒旦撒旦\n   撒旦撒是的撒`
    }
  },
}
</script>
<style lang="less" scoped>
.submit {
  padding: 5px 10px;
  color: #fff;
  width: max-content;
  border-radius: 3px;
  cursor: pointer;
  margin-left: 15px;
  border: 1px solid #dcdfe6;
  color: #606266;

  &.primary {
    background-color: #1e6fff;
    border: 1px solid #1e6fff;
    color: #fff;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/templateEdit.vue